import { render, staticRenderFns } from "./inject.vue?vue&type=template&id=52d29195&scoped=true&"
import script from "./inject.vue?vue&type=script&lang=js&"
export * from "./inject.vue?vue&type=script&lang=js&"
import style0 from "./inject.vue?vue&type=style&index=0&id=52d29195&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d29195",
  null
  
)

export default component.exports